import { render, staticRenderFns } from "./CardFundamentals.vue?vue&type=template&id=67dadc15&"
import script from "./CardFundamentals.vue?vue&type=script&lang=js&"
export * from "./CardFundamentals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports